<template>
  <v-app style="background-color: transparent;padding: 0;height: 100%;">
    <v-container style="background-color: transparent;padding: 0;overflow-y: auto; height: calc(100vh - 10vh); width: 100%">
      <v-row class="parabola" style="height: 35%;background: white; text-align: center; justify-content: center">
        <v-dialog transition="dialog-bottom-transition" max-width="600px">
          <template v-slot:activator="{ on }">
            <v-icon style="position: absolute; top: 10px; right: 20px;" v-on="on">
              mdi-earth
            </v-icon>
          </template>
          <template v-slot:default="dialog">
            <v-card class="dialogResetLanguage" dark>
              <h3 class="title-center">
                <br>{{ $t('Login.LanguageTitle') }}
              </h3>
              <v-card-text>
                <v-list color="primary" dark>
                  <v-list-item
                    v-for="(item, index) in items"
                    :key="index"
                    @click="changeLanguage(item.title)"
                  >
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-card-text>
            </v-card>
          </template>
        </v-dialog>
        <button class="v-btn-icon" @click="undo">
          <v-icon
            style="position: absolute; top: 10px; left: 15px;cursor: pointer;">
            mdi-undo-variant
          </v-icon>
        </button>
        <div style="margin-top: 20px;">
          <v-img src="/logo-dark.png" style="width: 40vh" />
        </div>
        <div>
          <h2 class="titol">
            {{ $t('Login.Welcome Back') }}
          </h2>
          <h2 class="titol">
            {{ $t('Login.SubTitle') }}
          </h2>
        </div>
      </v-row>
      <v-row style="height: 60%;background: transparent; justify-content: center;text-align: center;align-content: center; margin-top: 10%">
        <v-card flat style="background: transparent">
          <v-card-text style="padding: 0">
            <v-form v-model="valid">
              <div>
                <p>{{ $t('NIE/NIF') }}</p>
                <v-text-field
                  id="cif"
                  v-model="cif"
                  outlined
                  name="cif"
                  type="text"
                  :rules="rules.cif"
                  @keyup.enter="onSubmit('keyboard')"
                />
              </div>
              <div align="center">
                <p>{{ $t('Password') }}</p>
                <v-text-field
                  id="password"
                  v-model="password"
                  outlined
                  name="password"
                  type="password"
                  :rules="rules.password"
                  required
                  @keyup.enter="onSubmit('keyboard')"
                />
              </div>
            </v-form>
          </v-card-text>
          <div class="text-decoration-underline" align="center" style="padding-top: 5px;padding-bottom: 10px; cursor: pointer; color: dodgerblue; position: relative">
            <span class="text-decoration-underline" style="cursor: pointer; color: white" @click="showResetPass()">{{ $t('Login.Forgot Password?') }}</span>
          </div>
          <v-card-actions class="text-center" style="padding: 0px">
            <v-container style="padding: 0px">
              <v-row dense>
                <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                  <div align="center">
                    <v-btn class="btn-white" @click="onSubmit">
                      {{ $t('LOG IN') }}
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
              <v-row v-if="$user && !$user.registered" justify="center">
                <v-btn color="red" style="margin-top: 25px" dark depressed x-large @click="doLogout">
                  {{ $t('Login.LogoutUnregisteredUser') }}
                </v-btn>
              </v-row>
            </v-container>
          </v-card-actions><br>
          <div align="center" style="padding-top: 15px;color: white">
            <span>{{ $t('Login.New to Byppay?') }}</span>
          </div>
          <div align="center">
            <span class="white-text-underline" @click="goToRegister()">{{ $t('Sign Up') }}</span>
          </div>
          <v-btn class="btn-white" style="margin-top: 25px" @click="goToLanding">
            {{ $t('Login.about') }}
          </v-btn>
        </v-card>
      </v-row>
      <v-dialog v-model="loading" width="450">
        <v-card>
          <v-card-text class="pa-0" style="text-align: justify;">
            <Loading />
          </v-card-text>
        </v-card>
      </v-dialog>

      <v-app>
        <v-dialog
          v-model="resetPass"
          width="500"
        >
          <v-card>
            <v-card-title class="headline grey lighten-2">
              {{ $t('Login.Reset the Password!') }}
            </v-card-title>
            <v-card-text style="text-align: center;margin-top: 10px">
              <p style="color: black">
                {{ $t('E-mail') }}
              </p>
              <v-text-field
                v-model="emailReset"
                name="email"
                type="text"
                outlined
              />
              <i class="bar" />
            </v-card-text>

            <v-divider />

            <v-card-actions>
              <v-spacer />
              <v-btn
                class="btn-black"
                @click="reset()">
                {{ $t('Login.Send email') }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="mostrarResetPass"
          width="500"
        >
          <v-card>
            <v-card-title class="headline grey lighten-2">
              {{ $t('Login.Change the Password!') }}
            </v-card-title>

            <v-card-text>
              <div class="form-group">
                <div class="input-group">
                  <v-text-field
                    v-model="newPass"
                    :label="$t('Login.New Password')"
                    name="email"
                    type="password"
                  />
                  <i class="bar" />
                </div>
              </div>
              <div class="form-group">
                <div class="input-group">
                  <v-text-field
                    v-model="newPassConfirmation"
                    :label="$t('Login.New Password Confirmation')"
                    name="email"
                    outlined
                    type="password"
                  />
                  <i class="bar" />
                </div>
              </div>
            </v-card-text>
            <v-divider />
            <v-card-actions>
              <v-spacer />
              <v-btn
                color="primary"
                text
                @click="changePassword()"
              >
                <button class="btn btn-primary" style="margin: 5px;" type="submit">
                  {{ $t('Login.Change password') }}
                </button>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-app>
      <v-footer color="base" app style=" height:5%;background-color: #FFFFFF; font-size: 14px; position: absolute; padding: 20px 6px 6px">
        <h5>Byppay 2023 &copy;</h5>
        <h5 class="pointer" @click="privacyPolicy">
          {{ $t('|Policies') }}
        </h5>
        <v-spacer />
      </v-footer>
    </v-container>
    <SnackBar />
  </v-app>
</template>

<script>

import LocalRepository from "../repositories/LocalRepository";
import Loading from "../components/Loading";
import Constants from "../../constants";
import ApiRepository from "../repositories/ApiRepository";
import AuthRepository from "@/repositories/AuthRepository";
import SnackBar from "../components/SnackBar";
export default {
    name: 'LoginLayout',
    components: {Loading, SnackBar},
    data () {
        return {
            windowHeight: window.innerHeight,
            drawer: null,
            darkMode: false,
            tokenName: Constants.TOKEN_NAME,
            items: [
                { title: this.$t('Catalan') },
                { title: this.$t('Spanish') },
                { title: this.$t('English') },
            ],
            loading: false,
            fullscreen: false,
            fullscreenClass: "",
            fullscreenHide: "",


            emailReset: "",
            error: false,
            errorMsg: "",
            cif: null,
            password: "",
            token: "",
            newPass: "",
            newPassConfirmation: "",
            resetToken: "",
            valid: false,
            emailComp: null,
            resetPass: false,
            mostrarResetPass: false,
            rules: {
                cif: [
                    val => (val || '').length > 0 || 'This field is required'
                ],
                password: [
                    val => (val || '').length > 0 || 'This field is required'
                ]
            },
            googleSignInParams: {
                client_id: 'AIzaSyAjwTF-cpLA81M8YUSvJty1B7Y0qp7NCH8'
            }
        };
    },
    computed: {
        theme () {
            return (this.$vuetify.theme.dark) ? 'dark' : 'light';
        }
    },
    watch: {
        $route () {
            this.refreshCookiePolicity();
            this.token = this.$route.query.token;
            if (this.token !== undefined) {
                this.validateUser(this.token);
            }
            this.resetToken = this.$route.query.resetToken;
            if (this.resetToken !== undefined) {
                this.resetPass = false;
                this.mostrarResetPass = true;
            }
        },

    },
    mounted () {
        if (this.$route.params.color && this.$route.params.message) {
            this.$root.$emit('show-snackbar', {message: this.$route.params.message, color: this.$route.params.color});
        }
    },
    created () {
        if (this.$user) {
            this.$socket.emit('LOGIN', {id: this.$user._id});
        }
        const initialDark = LocalRepository.get('dark');
        if (initialDark) {
            this.$data.darkMode = initialDark.dark;
        }
        this.$root.$on('start-loading', () => {
            this.loading = true;
        });
        this.$root.$on('stop-loading', () => {
            this.loading = false;
        });

        this.$root.$on('fullscreen', () => {
            this.fullscreen = !this.fullscreen;
            if (this.fullscreen) {
                this.fullscreenClass = "full-screen";
                this.fullscreenHide = "full-screen-hide";
            } else {
                this.fullscreenClass = "";
                this.fullscreenHide = "";
            }
        });
        document.body.classList.remove("dark"); //desactivem dark mode que produeix la no visualització de moltes coses
        const showCookieConsent = localStorage.getItem('show-cookies-banner');
        if (showCookieConsent) {
            this.showCookieConsent = showCookieConsent !== "false";
        } else {
            this.showCookieConsent = true;
        }
        this.refreshCookiePolicity();

        this.$root.$on('log-google', (response) => {
            this.loadMain(response);
        });
        this.$root.$on('log-facebook', (response) => {
            this.loadMain(response);
        });
        const cifLoginRepository = LocalRepository.get('cif-user-compensation');
        if (cifLoginRepository) {
            this.cif = cifLoginRepository;
        }
        const emailLoginUser = localStorage.getItem('email-user-compensation');
        if (emailLoginUser) {
            this.emailComp = emailLoginUser;
        }
        this.token = this.$route.query.token;
        this.resetToken = this.$route.query.resetToken;

        const tokenLogin = LocalRepository.get('token');
        if (tokenLogin && this.$user && this.$user.registered) {
            this.$router.push({name: 'root', replace: true}).catch(() => {
            });
        } else if (this.token !== undefined) {
            this.validateUser(this.token);
        }
        if (this.resetToken !== undefined) {
            this.resetPass = false;
            this.mostrarResetPass = true;
        }
    },
    methods: {
        changeLanguage (lang) {
            let language = '';
            if (lang === 'Catalan' || lang === 'Català' || lang === 'Catalán') language = 'ca';
            if (lang === 'Spanish' || lang === 'Castellà' || lang === 'Español') language = 'es';
            if (lang === 'English' || lang === 'Anglès' || lang === 'Inglés') language = 'en';
            ApiRepository.changeLanguage(language)
                .then(() => {

                })
                .catch((err) => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Error changing language'), color: 'error'});
                    console.error(err);
                });
            localStorage.setItem('language', language);
            location.reload();
        },
        refreshCookiePolicity () {
            this.hideOverlay = this.$router.history.current.name === 'CookiePolicy';
        },
        privacyPolicy () {
            this.$router.push({name: 'PrivacyPolicy', replace: true});
        },

        doLogout () {
            LocalRepository.clear('token');
            this.$root.$emit('show-snackbar', {message: this.$t('Login.Logged out succesfully!'), color: "success"});
            location.reload();
        },

        showResetPass () {
            this.resetPass = true;
        },
        undo () {
            this.$router.push({name: 'LandinPage', params: {}, replace: true});
        },
        validateUser (token) {
            AuthRepository.validate(token)
                .then((response) => {
                    if (response && response.data && response.data.token) {
                        this.$root.$emit('show-snackbar', {message: response.data.msg, color: "success"});
                        this.cif = response.data.cif;
                    }
                })
                .catch((err) => {
                    let missatge = "";
                    if (err.response.data.errorCode === Constants.ERRORS.ERROR_USER_NOT_FOUND) {
                        missatge = this.$t('Login.ERROR: Invalid token, check again the URL on your e-mail');
                    } else if ( err.response.data.errorCode === Constants.ERRORS.ERROR_USER_ALREADY_VALIDATED) {
                        missatge = this.$t('Login.ERROR: You are already validated');
                    }
                    this.$root.$emit('show-snackbar', {message: missatge, color: "error"});
                })
                .finally(() => {
                    //console.log("END");
                });
        },
        onSubmit () {
            if (!this.cif || !this.password || this.cif === '' || this.password === '') {
                this.$root.$emit('show-snackbar', {message: this.$t('Login.You let empty params, check it again please'), color: 'error' });
            } else {
                AuthRepository.login(this.cif, this.password)
                    .then((response) => {
                        this.loadMain(response);
                        this.$root.$emit('show-snackbar', {message: this.$t('Login.Logged successfully!'), color: "success"});
                    })
                    .catch((err) => {
                        console.log(err);
                        let message = "";
                        if (err.response.data) {
                            if (err.response.data.errorCode === Constants.ERRORS.ERROR_MISSING_FIELDS) {
                                message = this.$t('Login.ERROR: Missing fields on the formulary');
                            } else if (err.response.data.errorCode === Constants.ERRORS.ERROR_USER_NOT_FOUND) {
                                message = this.$t('Login.ERROR: User not found');
                            } else if (err.response.data.errorCode === Constants.ERRORS.ERROR_WRONG_PASSWORD) {
                                message = this.$t('Login.ERROR: Wrong password');
                            } else if (err.response.data.errorCode === Constants.ERRORS.ERROR_MISSING_VALIDATION) {
                                message = this.$t('Login.ERROR: User is not validated');
                            } else if (err.response.data.errorCode === Constants.ERRORS.ERROR_GENERIC) {
                                message = this.$t('ERROR: Something went wrong');
                            }
                        } else {
                            message = err.message;
                        }
                        this.$root.$emit('show-snackbar', {message: message, color: "error"});
                    });
            }

        },
        loadMain (response) {
            if (response && response.data && response.data.token) {
                const connectionSocket = LocalRepository.get('connectionSocket');
                LocalRepository.set('token', response.data.token);
                if (connectionSocket) {
                    AuthRepository.saveSocket(connectionSocket).then(() => {}).finally(() => {
                        this.$root.$emit('check-user-cif', response.data.userId);
                        this.$root.$emit('show-splash-check', response.data.userCif);
                        this.$router.push({name: 'root', replace: true}).catch(() => {});
                    });
                } else {
                    this.$root.$emit('check-user-cif', response.data.userId);
                    this.$root.$emit('show-splash-check', response.data.userCif);
                    this.$router.push({name: 'root', replace: true}).catch(() => {});
                }
                //
            } else {
                this.$root.$emit('show-snackbar', {message: this.$t('ERROR: Something went wrong'), color: "error"});
            }
        },
        goRegister () {
            if (this.$router.history.current.name !== "register") {
                this.$router.push("register");
            }
        },
        goToLanding () {
            window.location.replace(Constants.LANDING_BASE_URL);
        },
        authenticate: function (provider) {
            this.$auth.authenticate(provider).then(() => {
                // Execute application logic after successful social authentication
            });
        },
        reset () {
            this.error = false;
            AuthRepository.resetPass(this.emailReset)
                .then(response => {
                    if (response) {
                        this.emailReset = "";
                        this.mostrarMiss = false;
                        this.resetPass = false;
                        this.$root.$emit('show-snackbar', {message: this.$t('Login.Check your email in order to reset the password')});
                    }
                })
                .catch((err) => {
                    this.error = true;
                    this.$root.$emit('show-snackbar', {message: this.$t('Login.Error: Cannot send an email to reset you password. Please check the email you enter.'), color: "error"});
                    console.log(err);
                })
                .finally(() => {
                });
        },
        changePassword () {
            this.error = false;
            if ( this.newPass === this.newPassConfirmation) {
                AuthRepository.changePass(this.newPass, this.resetToken)
                    .then(response => {
                        if (response) {
                            this.newPass = "";
                            this.newPassConfirmation = "";
                            this.mostrarResetPass = false;
                            this.mostrarMiss = false;
                            this.resetPass = false;
                            this.$root.$emit('show-snackbar', {message: this.$t('Login.You can now log in')});
                        }
                    }).catch((err) => {
                        this.$root.$emit('show-snackbar', {message: this.$t('Login.Error: Cannot find the current user. Please, try again later.'), color: "error"});
                        console.log(err);
                    }).finally(() => {  });
            } else {
                this.$root.$emit('show-snackbar', {message: this.$t('Login.Passwords doesn\'t match'), color: "error"});
            }
        },
        goToRegister () {
            this.$router.push({name: 'Register', replace: true});
        },
        goToInvoiceChats () {
            this.$router.push({name: 'InvoiceChats', replace: true});
        }
    },
    sockets: {
        CONNECTION_SOCKET (socket) {
            LocalRepository.set('connectionSocket', socket);
        }
    },
};
</script>

 <style scoped>
.dialogResetLanguage{
  position: absolute;
  margin: auto;
  border-top-left-radius: 70px;
  border-top-right-radius: 70px;
  left: 0;
  right: 0;
  bottom: 0;
  max-width: 600px;
  height: 40%;
  text-align: center;
  background: rgba(67, 225, 178, 0.95);
}
</style>
